import { useState } from 'react';

const RRSS = [
  { campo: 'instagram', label: 'Instagram', icono: '📸', placeholder: 'https://instagram.com/mi-negocio',  color: '#E1306C' },
  { campo: 'facebook',  label: 'Facebook',  icono: '👤', placeholder: 'https://facebook.com/mi-negocio',   color: '#1877F2' },
  { campo: 'tiktok',    label: 'TikTok',    icono: '🎵', placeholder: 'https://tiktok.com/@mi-negocio',    color: '#000000' },
  { campo: 'whatsapp',  label: 'WhatsApp',  icono: '💬', placeholder: '+56 9 1234 5678',                   color: '#25D366' },
];

export default function StepRRSSTercerTiempo({ datos, onNext, onBack, cargando }) {
  const [form, setForm] = useState({
    instagram: datos.instagram || '',
    facebook:  datos.facebook  || '',
    tiktok:    datos.tiktok    || '',
    whatsapp:  datos.whatsapp  || '',
  });
  const [error, setError] = useState('');

  const actualizar = (campo, valor) => {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setError('');
  };

  const handleNext = () => {
    const tieneAlguno = Object.values(form).some(v => v.trim().length > 0);
    if (!tieneAlguno) {
      setError('Agrega al menos una red social para que los equipos puedan ver tus servicios');
      return;
    }
    onNext({ rrss: form });
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Tus redes sociales</h2>
      <p style={styles.sub}>
        Los equipos visitarán tus redes para ver tu trabajo
        antes de contratarte. Agrega al menos una.
      </p>

      <div style={styles.lista}>
        {RRSS.map(({ campo, label, icono, placeholder, color }) => (
          <div key={campo} style={styles.rrssRow}>
            <div style={{ ...styles.rrssIcono, background: color }}>
              {icono}
            </div>
            <div style={styles.rrssInfo}>
              <div style={styles.rrssLabel}>{label}</div>
              <input
                value={form[campo]}
                onChange={e => actualizar(campo, e.target.value)}
                placeholder={placeholder}
                style={styles.input}
              />
            </div>
            {form[campo].trim().length > 0 && (
              <a
                href={campo == 'whatsapp'
                  ? `https://wa.me/${form[campo].replace(/\D/g, '')}`
                  : form[campo]}
                target="_blank"
                rel="noreferrer"
                style={styles.verLink}
              >
                Ver →
              </a>
            )}
          </div>
        ))}
      </div>

      <div style={styles.nota}>
        💡 Tip: Los negocios con Instagram activo reciben 3x más
        solicitudes que los que no tienen redes sociales.
      </div>

      {error && <p style={styles.error}>{error}</p>}

      <div style={styles.botones}>
        <button style={styles.btnBack} onClick={onBack}>← Atrás</button>
        <button style={{ ...styles.btnNext, opacity: cargando ? 0.7 : 1 }} onClick={handleNext} disabled={cargando}>
          {cargando ? 'Registrando...' : '¡Registrar negocio! ⚡'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 20, lineHeight: 1.5,
  },
  lista: {
    display: 'flex', flexDirection: 'column',
    gap: 12, marginBottom: 16,
  },
  rrssRow: {
    display: 'flex', alignItems: 'center', gap: 12,
  },
  rrssIcono: {
    width: 40, height: 40, borderRadius: 10,
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontSize: 18,
    flexShrink: 0,
  },
  rrssInfo: { flex: 1 },
  rrssLabel: {
    fontSize: 11, fontWeight: 700, color: '#6B7280',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 4,
  },
  input: {
    width: '100%', padding: '9px 12px',
    border: '1.5px solid #E8ECF4', borderRadius: 9,
    fontSize: 12, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
  },
  verLink: {
    fontSize: 12, fontWeight: 700,
    color: '#1A6BFF', textDecoration: 'none',
    flexShrink: 0,
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  nota: {
    background: '#FFF7ED',
    border: '1px solid #FED7AA',
    borderRadius: 10, padding: '12px 14px',
    fontSize: 12, color: '#92400E',
    fontFamily: "'Barlow', sans-serif",
    lineHeight: 1.5, marginBottom: 16,
  },
  error: {
    color: '#EF4444', fontSize: 12,
    fontFamily: "'Barlow', sans-serif", marginBottom: 12,
  },
  botones: { display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10 },
  btnBack: {
    padding: '13px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnNext: {
    padding: '13px', background: '#FF6B1A', border: 'none',
    borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800, color: 'white', cursor: 'pointer',
  },
};